import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BASE}/api` });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem('cap_token');
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});
